import React from "react";
import { Label } from "../ui/label";

// Pill Yes/No matching the mockup:
// - border-2 outline in unselected state
// - selected: primary border, primary-fixed/20 background, primary text
// - hover: surface-container-low
// - description subtext rendered below main label if `description` provided (mocked pattern)
export const YesNoRadio = ({ id, value, onChange, label, yesLabel, noLabel, description }) => {
  const pillBase =
    "px-6 py-3 rounded-full border-2 font-semibold text-sm transition-all cursor-pointer select-none";
  const unselected = {
    borderColor: "#dfe3e8",
    background: "transparent",
    color: "#3e4850",
  };
  const selected = {
    borderColor: "#00658D",
    background: "rgba(198,231,255,0.4)",
    color: "#00658D",
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-6 py-2">
      <div className="flex-1 min-w-0">
        <Label
          htmlFor={`${id}-yes`}
          className="font-medium text-base block"
          style={{ color: "#181c20" }}
        >
          {label}
        </Label>
        {description && (
          <p className="text-sm mt-1" style={{ color: "#6e7881" }}>
            {description}
          </p>
        )}
      </div>
      <div className="flex gap-3 shrink-0">
        <button
          type="button"
          onClick={() => onChange("yes")}
          className={pillBase}
          style={value === "yes" ? selected : unselected}
          onMouseEnter={(e) => {
            if (value !== "yes") e.currentTarget.style.background = "#f1f4f9";
          }}
          onMouseLeave={(e) => {
            if (value !== "yes") e.currentTarget.style.background = "transparent";
          }}
          data-testid={`${id}-yes`}
        >
          {yesLabel}
        </button>
        <button
          type="button"
          onClick={() => onChange("no")}
          className={pillBase}
          style={value === "no" ? selected : unselected}
          onMouseEnter={(e) => {
            if (value !== "no") e.currentTarget.style.background = "#f1f4f9";
          }}
          onMouseLeave={(e) => {
            if (value !== "no") e.currentTarget.style.background = "transparent";
          }}
          data-testid={`${id}-no`}
        >
          {noLabel}
        </button>
      </div>
    </div>
  );
};
